<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Souscriptions</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center row">
                                <div class="col-sm-1 col-md-1 mb-1">
                                    <select style="width:60px !important" class="form-control" v-model="tableData.length" @change="changePerPage()">
                                        <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                                    </select>
                                </div>
                                <div id="search_zone" class="mb-2 mr-1 text-right">

                                </div>
                            </div>
                            <v-table :columns="columns">
                                <tbody>
                                    <tr v-for="(item, key) in promotions" :key="key" @click="$router('/administration/souscriptions/show/'+item.uuid)" style="cursor:pointer">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.product }}</td>
                                        <td>{{ $format(item.amount) }}</td>
                                        <td>{{ item.treat_name }}</td>
                                        <td>{{ item.created_at }}</td>
                                        <td>
                                            <span v-if="item.status === 'add'" class="badge badge-pill badge-info">Paiement à la livraison</span>
                                            <span v-if="item.status === 'negotiated' && item.amount_negotiated !== null" class="badge badge-pill badge-info">Négocié</span>
                                            <span v-if="item.status === 'paid'" class="badge badge-pill badge-success">Payé</span>
                                            <span v-if="item.status === 'negotiated' && item.amount_negotiated === null" class="badge badge-pill badge-info">En négociation</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-table>
                            <v-paginate :pagination="pagination"
                                @prev="getPrev(pagination.prevPageUrl)"
                                @next="getNext(pagination.nextPageUrl)">
                            </v-paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {api, _buildQuery } from "../../../helpers/shared";
import vTable from '../../../components/vTable/vTable.vue';
import vPaginate from '../../../components/vTable/vPaginate.vue';
import customModal from '../../../components/modal/customModal.vue';
import axios from 'axios';
export default {
    components:{
        vTable, vPaginate, customModal
    },
    props: ['id'],
    data() {
        let sortOrders = {};
        let columns = [
            {width: '33%', label: 'reference', name: 'id' },
            {width: '33%', label: 'client', name: 'name'},
            {width: '33%', label: 'produit', name: 'product'},
            {width: '33%', label: 'montant(Fcfa)', name: 'amount'},
            {width: '33%', label: 'traité par', name: 'treat_name'},
            {width: '33%', label: 'date', name: 'created_at'},
            {width: '33%', label: 'statut', name: 'status'},
        ];
        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });
        return {
            promotions: [],
            columns: columns,
            sortKey: 'customer',
            sortOrders: sortOrders,
            perPage: ['10', '20', '30'],
            tableData: {
                page: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: ''
            },
            form:{
                name: '',
                perc: '',
                agency: ''
            },
            errors: [],
            loading: false,
            index: null,
        }
    },
    mounted(){
        this.getCodePromo()
    },
    methods:{
        changePerPage(url = 'administration/code-promo/subscriptions/'+this.id){
            this.tableData.page = 1;
            axios.get(api(url), {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.promotions = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getNext(url){
            this.tableData.page ++;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.users = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getPrev(url){
            this.tableData.page --;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.users = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getCodePromo(url = 'administration/code-promo/subscriptions/'+this.id) {
            this.tableData.page++;
            axios.get(api(url), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.promotions = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
        },
        configPagination(data) {
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
